import { useField } from 'formik';
import React, { useState } from 'react';
import { Error } from '../../error';
import { STANDARD_INPUT_HEIGHT } from '../../input';
import { Label } from '../../label';
import { TextField } from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { DatePickerInputType } from '../base';
import CalendarEventLineIcon from 'remixicon-react/CalendarEventLineIcon';

const getFormattedDate = (date: Date) => {
  return date.toLocaleDateString('en-CA');
};

export const DatePicker = ({ hideBorder = false, ...props }: DatePickerInputType) => {
  const [field, , { setValue }] = useField<Date | string | null | undefined>(props.name);
  const CustomField = () => {
    const value = field.value ? dayjs(getFormattedDate(new Date(field.value))) : null;
    const setFinalValue = (d: Date | null) => {
      setValue(d);
    };

    const MemoisedPicker = ({ value }: { value: Dayjs | null }) => {
      const [date, setDate] = useState(value);
      return (
        <MobileDatePicker
          maxDate={props.maxDate}
          minDate={props.minDate}
          className={` ${props.viewOnly && 'bg-surface-grey text-body-1 !text-grey-800'} ${
            !hideBorder && 'border-grey-300'
          } w-full flex-1 rounded-md border `}
          value={date}
          onChange={(e) => {
            if (e && dayjs(e).isValid()) {
              setDate(dayjs(e));
            }
          }}
          onClose={() => {
            setFinalValue(date ? new Date(date.toISOString()) : null);
            // props.onClose && props.onClose();
          }}
          InputProps={{
            style: {
              maxHeight: STANDARD_INPUT_HEIGHT,
              height: STANDARD_INPUT_HEIGHT,
              border: 'none',
            },
            endAdornment: (
              <div className="flex items-center justify-end">
                <CalendarEventLineIcon color="grey" size="20" />
              </div>
            ),
          }}
          renderInput={(params) => (
            <TextField
              sx={
                hideBorder
                  ? {
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: 'transparent',
                        },
                        '&:hover fieldset': {
                          borderColor: 'transparent',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'transparent',
                        },
                      },
                    }
                  : undefined
              }
              placeholder={props.title ? props.title : 'Select Date'}
              {...params}
            />
          )}
          disabled={props.disabled || props.viewOnly || false}
          disableFuture={props.disableFuture || false}
          disablePast={props.disablePast || false}
        />
      );
    };

    return (
      <div>
        {!hideBorder && <Label name={props.name} label={props.label} info={props.info} />}
        <MemoisedPicker value={value} />
        <Error name={props['name']} />
      </div>
    );
  };

  return <CustomField />;
  // return <Field name={props.name} component={CustomField} />;
};
export default DatePicker;
